import { useMediaQuery } from '@mantine/hooks';
import useStore from '@store/index';
import FinalOffsetSummaryCart from '../../FinalOffsetSummaryCart/FinalOffsetSummaryCart';
import SelectedFinancedProjectsSection from '../../SelectedFinancedProjectsSection/SelectedFinancedProjectsSection';
import SelectedProjectsSection from '../../SelectedProjectsSection/SelectedProjectsSection';

import { Button, Text } from '@components/v2/ui';
import {
	Box,
	Flex,
	Grid,
	Modal,
	Stack,
} from '@mantine/core';
import { useTranslation } from 'react-i18next';

const Step4 = () => {
	const isMobile = useMediaQuery('(max-width: 868px)');
	const {
		setSuccessModalOpened,
		successModalOpened,
		setIsAddOffset,
		setOffsetAdditionalProjects,
		setOffsetCreationActiveStep,
		setOffsetAdditionalProjectsSelected,
		setOffsetMesurabilityProjects,
		setOffsetMesurabilityProjectsSelected,
		setOffsetProjectMixinAco2,
		setOffsetProjectMixinAddi,
		setOffsetStep2Error,
		setOffsetStep3Error,
		setOffsetCreationDatas,
		setOffsetMesurabilityProjectsPage,
		setOffsetAdditionalProjectsPage,
		setCurrentStepOffsetCreate,

		offsetCreationDatas,
		offsetMesurabilityProjectsSelected,
	} = useStore();

	const { t } = useTranslation();

	return (
		<Box mt={'48px'}>
			<Modal
				opened={successModalOpened}
				onClose={() => {
					setSuccessModalOpened(false);
					setIsAddOffset(false);
				}}
				centered
				withCloseButton={false}
				overlayProps={{
					opacity: 0.55,
					blur: 2,
				}}
				radius="lg"
				styles={{
					body: {
						padding: '0px',
					},
					content: {
						background: 'white',
						borderRadius: '20px',
						maxWidth: '480px',
					},
				}}
			>
				<Stack
					style={{
						padding: '32px 64px',
					}}
					align="center"
					gap={'24px'}
				>
					{/* Icône verte */}
					<svg
						xmlns="http://www.w3.org/2000/svg"
						width="82"
						height="82"
						viewBox="0 0 82 82"
						fill="none"
					>
						<path
							d="M51.2502 32.4583L35.8752 51.25L29.0418 44.4167M72.6043 41C72.6043 58.4545 58.4547 72.6042 41.0002 72.6042C23.5457 72.6042 9.396 58.4545 9.396 41C9.396 23.5455 23.5457 9.39584 41.0002 9.39584C58.4547 9.39584 72.6043 23.5455 72.6043 41Z"
							stroke="#2C8C5E"
							stroke-width="3"
							stroke-linecap="round"
							stroke-linejoin="round"
						/>
					</svg>

					{/* Texte */}
					<Text variant="body2" ta="center">
						{t('global.successOffsetCreationMessage')}
					</Text>

					<Button
						onClick={() => {
							setIsAddOffset(false);
							setSuccessModalOpened(false);
							setCurrentStepOffsetCreate(0);

							setOffsetCreationActiveStep(0);
							setOffsetAdditionalProjects([]);
							setOffsetAdditionalProjectsSelected([]);
							setOffsetMesurabilityProjects([]);
							setOffsetMesurabilityProjectsSelected([]);
							setOffsetProjectMixinAco2([]);
							setOffsetProjectMixinAddi([]);
							setOffsetStep2Error(false);
							setOffsetStep3Error(false);
							setOffsetCreationDatas({});
							setOffsetMesurabilityProjectsPage(1);
							setOffsetAdditionalProjectsPage(1);
						}}
						radius="xl"
						size="md"
						variant={'primary'}
						style={{ width: '200px' }}
					>
						{t('global.continue')}
					</Button>
				</Stack>
			</Modal>
			<Flex
				direction={isMobile ? 'column-reverse' : 'row'}
				gap={'24px'}
			>
				<Stack gap={'24px'} w={'100%'}>
					<Grid grow>
						<Grid.Col span={8}>
							<SelectedProjectsSection />
						</Grid.Col>
						<Grid.Col span={4}>
							<FinalOffsetSummaryCart
								quantityOffset={
									offsetCreationDatas.quantity
								}
								offsetMesurabilityProjectsSelected={
									offsetMesurabilityProjectsSelected
								}
							/>
						</Grid.Col>
					</Grid>

					<SelectedFinancedProjectsSection />
				</Stack>
			</Flex>
		</Box>
	);
};

export default Step4;
